module.exports = __webpack_public_path__ + "static/media/Obi-Wan Kenobi.f451e481.jpg";